import React, { useState } from "react";
import SbuxTextField from "../../../../../components/SubxTextField";
import SbuxTranslate from "../../../../../components/SbuxTranslate";
import { Box } from "@mui/material";
import { getTextLengthErrorMessage } from "../../utils";
import styles from "../../styles";
import useCss from "../../../../../hooks/useCss";

interface TemporaryMsgAddProps {
  row: Record<string, unknown>;
  sequenceNumber?: string | number;
  handleTemporaryMsgRow: (row: Record<string, unknown>) => void;
}

const TemporaryMsgAdd = ({
  row,
  sequenceNumber,
  handleTemporaryMsgRow,
}: TemporaryMsgAddProps) => {
  const classes = useCss(styles);
  // const descriptionPlaceHolder = useTextTranslate("Description");
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);
  const [code] = useState(sequenceNumber);
  const [info, setInfo] = useState("");
  const [rowObj, setRowObj] = useState(row);
  const [fileNameLengthError, setFileNameLengthError] = useState(false);

  const handleDescriptionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    setDescription(value);
    setDescriptionError(value.length < 1 ? true : false);
    const addRow = {
      ...rowObj,
      description: value,
    };
    setRowObj(addRow);
    handleTemporaryMsgRow(addRow);
  };

  const handleInfoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInfo(value);
    const addRow = {
      ...rowObj,
      info: value,
    };
    if (value.length === 150) {
      setFileNameLengthError(true);
    } else {
      setFileNameLengthError(false);
    }
    setRowObj(addRow);
    handleTemporaryMsgRow(addRow);
  };

  return (
    <Box>
      <Box
        component="form"
        className={classes.formControl}
        noValidate
        autoComplete="off"
      >
        <Box>
          <SbuxTextField
            label={<SbuxTranslate>{"Code"}</SbuxTranslate>}
            disabled
            preventAutoFocus
            value={code}
          />
        </Box>

        <Box>
          <SbuxTextField
            label={<SbuxTranslate>{"Description"}</SbuxTranslate>}
            // placeholder={descriptionPlaceHolder}
            value={description}
            handleChange={handleDescriptionChange}
            errorMessage={"Description required at least 1 character"}
            isError={descriptionError}
            error={descriptionError}
            required
          />
        </Box>

        <Box>
          <SbuxTextField
            label={<SbuxTranslate>{"Info"}</SbuxTranslate>}
            value={info}
            handleChange={handleInfoChange}
            errorMessage={
              fileNameLengthError ? getTextLengthErrorMessage(150) : null
            }
            isError={fileNameLengthError}
            error={fileNameLengthError}
            displayCounter={true}
            maxLength={150}
            multiline={true}
            preventAutoFocus={true}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TemporaryMsgAdd;
